export const IDENTIFY_USER = 'IDENTIFY_USER'
export const IDENTIFY_USER_ERR = 'IDENTIFY_USER_ERR'
export const RESET_IDENTIFY_USER = 'RESET_IDENTIFY_USER'